// Recommended by
window.addEventListener("load", function () {
  const swiper = new Swiper(".section-recommended__swiper", {
    slidesPerView: "auto",
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    breakpoints: {
      768: {
        spaceBetween: 40,
      },
    },
  });
});

// We helped
window.addEventListener("load", function () {
  const swiper = new Swiper(".section-helped__swiper", {
    slidesPerView: "auto",
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    breakpoints: {
      768: {
        spaceBetween: 15,
      },
    },
  });
});
